import { on } from "delegated-events";

const handleAddChild = (e) => {
  const button = e.target.closest("button");
  const form = e.target.closest(".interest-form");
  const nextField = form.querySelector(".additional-child-field.hidden");
  const footnote = form.querySelector(".add-child-footnote");

  if (nextField) {
    nextField.classList.remove("hidden");
  }

  if (form.querySelectorAll(".additional-child-field.hidden").length === 0) {
    button.parentNode.classList.add("hidden");
    footnote.classList.remove("hidden");
  }
};

const handleRemoveChild = (e) => {
  const form = e.target.closest(".interest-form");
  const field = e.target.closest(".additional-child-field");
  const addControls = form.querySelector(".add-child-controls");
  const footnote = form.querySelector(".add-child-footnote");

  field.querySelector('input[type="text"]').value = null;
  field.classList.add("hidden");

  addControls.classList.remove("hidden");
  footnote.classList.add("hidden");
};

const handleSubmit = (e) => {
  const form = e.detail.form;

  if (!form.classList.contains("interest-form")) {
    return;
  }

  const childFields = form.querySelectorAll(".additional-child-field");
  const addControls = form.querySelector(".add-child-controls");
  const footnote = form.querySelector(".add-child-footnote");

  addControls.classList.remove("hidden");
  footnote.classList.add("hidden");
  childFields.forEach((x) => x.classList.add("hidden"));
};

export default {
  init: () => {
    on("click", ".interest-form .add-child-controls button", handleAddChild);
    on("click", ".interest-form .remove-child", handleRemoveChild);
    on("styledform:submit", "html", handleSubmit);
  },
};
